import {
  intersection,
  some,
  keys,
  reduce,
  map,
  object,
} from 'underscore';
import { convertFilterEntityToExpressions } from '@bingads-webui/filter-commons';
import { editorialErrorCodeToErrorMessageMapping } from '@bingads-webui-campaign/api-errors';

const rejectionIds = [
  3,
  4,
  5,
  7,
  9,
  10,
  14,
  16,
  17,
  18,
  19,
  20,
  22,
  23,
  25,
  26,
  28,
  31,
  32,
  33,
  35,
  38,
  40,
  41,
  42,
  46,
  48,
  49,
  50,
  51,
  52,
  54,
  55,
  59,
  62,
  63,
  64,
  65,
  66,
  67,
  85,
  88,
  89,
  90,
  91,
  92,
  93,
  94,
  95,
  96,
  100,
  101,
  102,
  103,
  104,
  105,
  106,
  107,
  108,
  109,
  110,
  111,
  112,
  113,
  114,
  115,
  116,
  117,
  118,
  119,
  120,
  121,
  122,
  123,
  124,
  125,
  128,
  129,
  130,
  131,
  132,
  133,
  134,
  135,
  136,
  137,
  138,
  139,
  140,
  141,
  142,
  143,
  144,
  145,
  146,
  147,
  148,
  149,
  150,
  151,
  152,
  153,
  154,
  156,
  157,
  158,
  159,
  160,
  161,
  162,
  163,
  164,
  165,
  166,
  176,
  177,
  178,
  179,
  180,
  182,
  183,
  184,
  198,
  199,
  237,
  238,
  239,
  242,
  243,
  248,
  250,
  251,
  255,
  256,
  257,
  258,
  259,
  260,
  261,
  262,
  263,
  264,
  265,
  266,
  267,
  268,
  269,
  270,
  271,
  272,
  273,
  274,
  275,
  276,
  277,
  278,
  279,
  280,
  281,
  282,
  283,
  284,
  285,
  286,
  287,
  288,
  289,
  290,
  291,
  295,
  299,
  303,
  307,
  311,
  315,
  319,
  323,
  327,
  331,
  335,
  339,
  340,
  341,
  342,
  343,
  344,
  345,
  346,
  347,
  348,
  349,
  351,
  5158,
  5159,
  5160,
  5161,
  5162,
  5163,
  5164,
  5165,
  5166,
  5167,
  5198,
  5199,
  5200,
  5201,
  5202,
  5203,
  5204,
  5212,
  8141,
  8142,
  8155,
  8159,
  8163,
  8168,
  8174,
  8180,
  8186,
  8192,
  8198,
  8204,
  8210,
  8216,
  8222,
  8228,
  8234,
  8240,
  8246,
  8252,
  8258,
  8264,
  8270,
  8276,
  8292,
  8298,
  8304,
  8310,
  8316,
  8322,
  8328,
  8334,
  8340,
  8346,
  8352,
  8358,
  8364,
  8370,
  8376,
  8382,
  8388,
  8394,
  8400,
  8406,
  8412,
  8418,
  8424,
  8430,
  8436];

const getLocalizedRejectionReasons = i18n => map(rejectionIds, (id) => {
  const formatKey = `Error_Editorial_Raw_${id}`;
  const formatKeyWithSurfix = `Error_Editorial_Raw_${id}_1`;
  const defaultKey = 'EditorialReasons_Default';
  const localizedKey = editorialErrorCodeToErrorMessageMapping[formatKey] ||
    editorialErrorCodeToErrorMessageMapping[formatKeyWithSurfix] ||
    editorialErrorCodeToErrorMessageMapping[defaultKey];

  return i18n.getString(localizedKey);
});

export const getLocalizedEditorialRejectionReasons = (i18n) => {
  const localizedRejectionReasons = getLocalizedRejectionReasons(i18n);

  return object(rejectionIds, localizedRejectionReasons);
};

export const getDisabledSaveFilterButtonWithReasonFunc =
  (i18n, readOnlyProperties) => ({ editableFilter } = {}) => {
    let disabledSaveFilter = false;

    if (editableFilter && editableFilter.query) {
      const editableExpressions = convertFilterEntityToExpressions(editableFilter);
      // hide editable filter when there is readonly properities
      const filterKeys = reduce(editableExpressions, (memo, item) => [...keys(item), ...memo], []);
      disabledSaveFilter = some(intersection(filterKeys, readOnlyProperties));
    }

    if (disabledSaveFilter) {
      return i18n.getString(_TL_('remove read-only filter to enable save filter button'));
    }

    return '';
  };
